module.exports = __webpack_public_path__ + "static/img/footer_img.03750ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_img.png
// module id = FzC2
// module chunks = 16